module.exports = __webpack_public_path__ + "static/img/netflix-step1.00c53dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/netflix-step1.png
// module id = 142
// module chunks = 1